import { PatientProps } from '../contexts/PatientContext';
import { makeError } from '../utils/error';
import { Patient, PatientScheduleBuilder } from './Patient';
import { Payment } from './Schedule';
import { ScheduleSpecialist, ScheduleSpecialistBuilder } from './ScheduleSpecialist';

export type ScheduleSpecialistRequest = {
  patient: Patient;
} & Omit<ScheduleSpecialist, 'idPatient' | 'dateHours' | 'image'>;

interface IPayment {
  type?: string;
  price?: string;
  healthInsurance?: {
    id: string;
    name: string;
    external_id: string | null;
  };
  healthPlan?: {
    id: string;
    name: string;
    external_id: string | null;
  };
}

export const ScheduleSpecialistRequestBuilder = (specialistSchedule?: ScheduleSpecialist) => {
  const schedule = {} as ScheduleSpecialistRequest;
  const payment = {} as Payment;

  const specialistScheduleValid = ScheduleSpecialistBuilder(specialistSchedule).validateSchedule();

  const checkPropertyError = () => {
    if (!schedule.patient) makeError('Missing schedule.patient property');
  };

  function setPatient(patientSchedule: PatientProps) {
    const patient = PatientScheduleBuilder(patientSchedule.name);
    patient.setBirthDate(patientSchedule.birthDate);
    patient.setDocument(patientSchedule.document, patientSchedule.documentType);
    patient.setEmail(patientSchedule.email);
    patient.setPhone(patientSchedule.phone);
    patient.setGender(patientSchedule.gender);
    patient.setIsPregnant(patientSchedule.pregnant);
    schedule.patient = patient.build();
  }

  function setPayment(props: IPayment) {
    payment.type = Number(props.type);
    payment.price = props.price;
    if (props.healthInsurance) {
      payment.healthInsurance = {
        ...props.healthInsurance,
        external_id: props.healthInsurance.external_id ? String(props.healthInsurance.external_id) : null
      };
    }
    if (props.healthPlan) {
      payment.healthPlan = {
        ...props.healthPlan,
        external_id: props.healthPlan.external_id ? String(props.healthPlan.external_id) : null
      };
    }
  }

  function build() {
    schedule.date = specialistScheduleValid.date;
    schedule.hour = specialistScheduleValid.hour;
    schedule.attendanceType = specialistScheduleValid.attendanceType;
    schedule.interval = specialistScheduleValid.interval;
    schedule.catalog = specialistScheduleValid.catalog;
    schedule.resource = specialistScheduleValid.resource;
    schedule.unit = specialistScheduleValid.unit;
    schedule.payment = payment;
    schedule.appointmentType = specialistScheduleValid.appointmentType;
    checkPropertyError();
    return schedule;
  }

  return {
    build,
    setPatient,
    setPayment
  };
};
